import React from 'react';
import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';

// import faBrands from '@fortawesome/fontawesome-free-brands'
// import faSolid from '@fortawesome/fontawesome-free-solid'
// import faEnvelope from '@fortawesome/fontawesome-free-regular/faEnvelope'
// import faLink from '@fortawesome/fontawesome-pro-regular/faLink';
// import faRegular from '@fortawesome/fontawesome-pro-regular'
// import faRssSquare from '@fortawesome/fontawesome-pro-regular/faRssSquare';



import { 
  faTiktok,
  faPinterestP as faPinterest,
  faFacebookMessenger,
  faTelegramPlane,
  faWeixin//,
  // faLinkedinIn
} from '@fortawesome/free-brands-svg-icons';


import { 
  faEnvelope
} from '@fortawesome/free-regular-svg-icons';

import { 
  faRssSquare,
  faLink
} from '@fortawesome/pro-regular-svg-icons';



// fontawesome.library.add(faBrands)
// fontawesome.library.add(faSolid)

const getFaIcon = (type) => {
  switch (type){
    // case 'facebook':
      // return faFacebook;
    case 'messenger':
      return faFacebookMessenger;
    case 'telegram':
      return faTelegramPlane;
    case 'wechat':
      return faWeixin;
    case 'pinterest':
      return faPinterest;
    case 'linkedin':
      return ['fab', 'linkedin-in'];
    case 'snapchat':
      return ['fab', 'snapchat-ghost'];
    case 'tiktok':
      return faTiktok;
    case 'twitch':
      return ['fab', 'twitch'];
    case 'call':
      return ['fas', 'phone'];
    case 'email':
      return faEnvelope;//['fas', 'envelope'];
    case 'feed':
      return faRssSquare;
    case 'basic':
      return faLink;
    default:
      return ['fab', type];
  }
}

const NetworkIcon = ({type}) => {
  return (type && <FA icon={getFaIcon(type)} className="fa-network" title={`${type}`} />)
};

export default NetworkIcon;


// WEBPACK FOOTER //
// ./src/components/SmartLinks/NetworkIcon.js